import {createSlice, PayloadAction} from '@reduxjs/toolkit';
//types
import {INotification, INotificationReducer} from '../../utils/types';
//actions
import {getAllNotifications} from './actions';
//operations
import {getAllNotificationData, pendingOperation, rejectedOperation} from './operations';

export const initialState: INotificationReducer = {
	unreadNotificationData: {
		notifications: [],
		totalCount: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 0,
	},
	allNotificationData: {
		notifications: [],
		totalCount: 0,
		totalPages: 0,
		currentPage: 0,
		pageSize: 0,
	},
	isLoading: false,
};

interface AddNotificationPayload {
	notification: INotification;
	target: 'unread' | 'all' | 'both';
}

interface SetNotificationsPayload {
	notifications: INotification[];
	target: 'unread' | 'all';
}

const notificationStore = createSlice({
	name: 'notification',
	initialState,
	reducers: {
		addNotification: (state, action: PayloadAction<AddNotificationPayload>) => {
			const {notification, target} = action.payload;

			if (target === 'unread' || target === 'both') {
				state.unreadNotificationData.notifications.unshift(notification);
				state.unreadNotificationData.totalCount += 1;
			}
			if (target === 'all' || target === 'both') {
				state.allNotificationData.notifications.unshift(notification);
				state.allNotificationData.totalCount += 1;
			}
		},
		setNotifications: (state, action: PayloadAction<SetNotificationsPayload>) => {
			const {notifications, target} = action.payload;

			if (target === 'unread') {
				state.unreadNotificationData.notifications = notifications;
			} else {
				state.allNotificationData.notifications = notifications;
			}
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getAllNotifications.pending, pendingOperation);
		builder.addCase(getAllNotifications.fulfilled, getAllNotificationData);
		builder.addCase(getAllNotifications.rejected, rejectedOperation);
	},
});

export const {setNotifications, addNotification} = notificationStore.actions;
export default notificationStore.reducer;
